/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Options_Quicktools_Manual_QcInputs */

const en_options_quicktools_manual_qc = /** @type {(inputs: Options_Quicktools_Manual_QcInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Manual QC`)
};

const fr_options_quicktools_manual_qc = /** @type {(inputs: Options_Quicktools_Manual_QcInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`QC manuel`)
};

const de_options_quicktools_manual_qc = /** @type {(inputs: Options_Quicktools_Manual_QcInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Manuelle Qualitätskontrolle`)
};

const it_options_quicktools_manual_qc = /** @type {(inputs: Options_Quicktools_Manual_QcInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Controllo qualità manuale`)
};

const ru_options_quicktools_manual_qc = /** @type {(inputs: Options_Quicktools_Manual_QcInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ручной контроль качества`)
};

const es_options_quicktools_manual_qc = /** @type {(inputs: Options_Quicktools_Manual_QcInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Control de calidad manual`)
};

const zh_cn2_options_quicktools_manual_qc = /** @type {(inputs: Options_Quicktools_Manual_QcInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`人工质检`)
};

const ja_options_quicktools_manual_qc = /** @type {(inputs: Options_Quicktools_Manual_QcInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`手動QC`)
};

const hi_options_quicktools_manual_qc = /** @type {(inputs: Options_Quicktools_Manual_QcInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`मैनुअल क्यूसी`)
};

const pt_pt2_options_quicktools_manual_qc = /** @type {(inputs: Options_Quicktools_Manual_QcInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Controle de qualidade manual`)
};

/**
* | output |
* | --- |
* | "Manual QC" |
*
* @param {Options_Quicktools_Manual_QcInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const options_quicktools_manual_qc = /** @type {((inputs?: Options_Quicktools_Manual_QcInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Options_Quicktools_Manual_QcInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_options_quicktools_manual_qc(inputs)
	if (locale === "de") return de_options_quicktools_manual_qc(inputs)
	if (locale === "it") return it_options_quicktools_manual_qc(inputs)
	if (locale === "ru") return ru_options_quicktools_manual_qc(inputs)
	if (locale === "es") return es_options_quicktools_manual_qc(inputs)
	if (locale === "zh-CN") return zh_cn2_options_quicktools_manual_qc(inputs)
	if (locale === "ja") return ja_options_quicktools_manual_qc(inputs)
	if (locale === "hi") return hi_options_quicktools_manual_qc(inputs)
	if (locale === "pt-PT") return pt_pt2_options_quicktools_manual_qc(inputs)
	return en_options_quicktools_manual_qc(inputs)
});